let yandexTurboId = process.env.APP_YANDEX_TURBOAPP_ID;

if (!yandexTurboId) {
  yandexTurboId = '1e10003b9af04411a9bdf71080719ba7';
}

module.exports = {
  yandexTurboId,
};
